import * as React from 'react';
import { getImagePath } from '../../../utilities/product';
import { Loader } from '../Loader/Loader';
import styled from 'styled-components';

interface ImageProps {
  src: string | null;
  placeholder: string;
  retinaPlaceholder?: string;
  className?: string;
  w?: number;
  h?: number;
  width?: number;
  height?: number;
  notLazyloading?: boolean;
  notResize?: boolean;
  notWebp?: boolean;
  onClick?: () => void;
  ignoreRequestHeight?: boolean;
  alt?: string;
  fetchPriority?: string;
  aspectRatio?: string;
  sizes?: { minWidth: number; imageWidth: number; imageHeight: number }[];
  useRetina?: boolean;
  resizeType?: string;
  showLoader?: boolean;
  quality?: number;
  wrapperWidth?: string;
  display?: string;
}

interface ImageState {
  loaded: boolean;
}

class ImagePlaceholder extends React.PureComponent<ImageProps, ImageState> {
  constructor(props: ImageProps) {
    super(props);
    this.state = { loaded: false };
    this.handleImageLoad = this.handleImageLoad.bind(this);
  }

  handleImageLoad() {
    this.setState({ loaded: true });
  }

  public renderImage() {
    const {
      src,
      placeholder,
      retinaPlaceholder,
      className,
      w,
      h,
      width,
      height,
      notResize,
      notWebp,
      onClick,
      ignoreRequestHeight,
      alt,
      notLazyloading,
      fetchPriority,
      aspectRatio,
      sizes,
      useRetina,
      resizeType,
      showLoader,
      quality,
      wrapperWidth,
      display,
    } = this.props;
    const srcSize = { width: w ? w : 100, height: h ? h : 100 };
    const srcSetSize = { width: w ? w * 2 : 100, height: h ? h * 2 : 100 };

    const srcSetArray: (string | undefined)[] = [];

    if (useRetina) {
      srcSetArray.push(
        src &&
          src !== 'undefined.png' &&
          src.constructor !== Object &&
          retinaPlaceholder
          ? getImagePath(
              src,
              srcSetSize,
              !notResize,
              notWebp,
              false,
              ignoreRequestHeight,
              resizeType,
              quality,
            ) + ' 2x'
          : retinaPlaceholder,
      );
    }

    if (sizes) {
      for (const size of sizes) {
        srcSetArray.push(
          `${getImagePath(
            src,
            { width: size.imageWidth, height: size.imageHeight },
            !notResize,
            notWebp,
            false,
            ignoreRequestHeight,
            resizeType,
            quality,
          )} ${size.minWidth}w`,
        );
      }
    }

    return (
      <div
        style={{
          position: 'relative',
          display: display ? display : 'inline-block',
          width: wrapperWidth,
        }}
      >
        {!this.state.loaded && showLoader && (
          <LoaderWrapper>
            <Loader loading={true} />
          </LoaderWrapper>
        )}

        {React.createElement('img', {
          width: width,
          height: height,
          src:
            src && src !== 'undefined.png' && src.constructor !== Object
              ? getImagePath(
                  src,
                  srcSize,
                  !notResize,
                  notWebp,
                  false,
                  ignoreRequestHeight,
                  resizeType,
                  quality,
                )
              : placeholder,
          srcSet: srcSetArray.filter((o) => o).join(', '),
          sizes: sizes
            ?.map(
              (size) => `(min-width: ${size.minWidth}px) ${size.minWidth}px`,
            )
            .join(', '),
          className: className,
          loading: notLazyloading ? 'eager' : 'lazy',
          onClick: onClick,
          alt: alt ? alt : '',
          fetchPriority: fetchPriority,
          style: {
            aspectRatio: aspectRatio,
          },
          onLoad: this.handleImageLoad,
        })}
      </div>
    );
  }

  public render() {
    return this.renderImage();
  }
}

const LoaderWrapper = styled.div`
  position: 'absolute',
  top: 0,
  left: 0,
  width: width || '100%',
  height: height || '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f0f0f0',
  zIndex: 1,
`;

export default ImagePlaceholder;
